<div class="fw-bold bg-white p-3 rounded-5 mb-5 shadow">
    <!-- Primera fila -->
    <div class="d-flex justify-content-between">
        <div>
            <label for="information" class="labelInformation">
                Assign Device to Plan
            </label>
        </div>
        <div class="col btn-back text-end">
            <a class="btn btn-secondary" (click)="goBack()">Back</a>
        </div>
    </div>


    <app-device-form [userPlans]="listPlans" [iccid]="iccid" [isEditing]="true" (handleCreateUpdateResponse)="handleCreateUpdateResponse($event)"></app-device-form>

</div>

<div id="customerCreateTicketModal" class="modal fade"  tabindex="-1"  aria-hidden="true">
  <div class="modal-dialog modal-xl">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title"  style="font-weight: bold">
          Create Ticket
        </h5>
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"
          ></button>
      </div>
      <div class="modal-body">
        <app-create-ticket-form [isEditing]="false" [iccid]="iccid" [errorMessage]="errorMessage"  (handleCreateUpdateResponse)="handleTicketResponse($event)"></app-create-ticket-form>
      </div>
    
    </div>
  </div>
</div>

<app-modal-alert-control [id]="'createTicketAlert'" [header]="'Activation Warning'" [body]="'We encountered errors while activating and assigning your device to a plan. Please create a support ticket or call +1 844-LINKWORX'" [okButtonText]="'Create'" (onOkButtonClick)="onOkButtonClick($event)"></app-modal-alert-control>